export function getMultiToneGradientColor(
  colors: string | string[],
) {
  switch (colors?.length) {
    case 1:
      return `${colors[0]} no-repeat`;
    case 2:      
        return `linear-gradient(to right, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%, ${colors[1]} 100%) no-repeat`;
    case 3:
      return `linear-gradient(to right, ${colors[0]} 0%, ${colors[0]} 33%, ${colors[1]} 33%, ${colors[1]} 66%, ${colors[2]} 66%, ${colors[2]} 100%) no-repeat`;
    case 4:
      return `linear-gradient(to right, ${colors[0]} 0%, ${colors[0]} 25%, ${colors[1]} 25%, ${colors[1]} 50%, ${colors[2]} 50%, ${colors[2]} 75%, ${colors[3]} 75%, ${colors[3]} 100%) no-repeat`;
    case 5:
      return `linear-gradient(to right, ${colors[0]} 0%, ${colors[0]} 20%, ${colors[1]} 20%, ${colors[1]} 40%, ${colors[2]} 40%, ${colors[2]} 60%, ${colors[3]} 60%, ${colors[3]} 80%, ${colors[4]} 80%, ${colors[4]} 100%) no-repeat`;
    default:
      return "#fff";
  }
}
